/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const AdminActionTypeDto = {
    SetCandidatePositiveFeedback: 'SET_CANDIDATE_POSITIVE_FEEDBACK',
    SetCandidateGender: 'SET_CANDIDATE_GENDER',
    SetOnHoldAdmin: 'SET_ON_HOLD_ADMIN',
    SetCandidateNegativeFeedback: 'SET_CANDIDATE_NEGATIVE_FEEDBACK'
} as const;

export type AdminActionTypeDto = typeof AdminActionTypeDto[keyof typeof AdminActionTypeDto];



